import { useState, type FormEvent } from "react";
import { Trans } from "@lingui/react/macro";
import { useAuth } from "../auth.js";

export function Login() {
  const { login, loading, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const submit = (e: FormEvent) => {
    e.preventDefault();
    void login(email, password);
  };

  return (
    <div className="login">
      <form onSubmit={submit}>
        <h1>Jalfa AI · Admin</h1>
        <p className="muted"><Trans>Sign in with your administrator account.</Trans></p>
        <label>
          <span><Trans>Email</Trans></span>
          <input
            type="email"
            autoComplete="username"
            autoFocus
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label>
          <span><Trans>Password</Trans></span>
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {error && <div className="banner err">{error}</div>}
        <button type="submit" disabled={loading}>
          {loading ? <Trans>Signing in…</Trans> : <Trans>Sign in</Trans>}
        </button>
      </form>
    </div>
  );
}
